import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/warehouse/metrics")({
  component: () => (
    <Breadcrumb label="Metrics" to="/warehouse/metrics">
      <Outlet />
    </Breadcrumb>
  ),
});
